import { useTheme } from '@mui/material';

export const IntroIcon2 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            viewBox="0 0 48 49"
            className={className}
        >
            <path
                fill={primaryIconStrokeColor}
                d="M18.886 6.282a3.527 3.527 0 0 1 2.763 0l9.769 4.145c1.216.514 2.123 1.714 2.117 3.162-.027 5.484-2.283 15.518-11.807 20.079a3.377 3.377 0 0 1-2.92 0c-5.162-2.472-8.187-6.553-9.881-10.645l1.932.012c1.586 3.472 4.243 6.831 8.524 8.941V7.995l-9.574 4.057c-.625.266-1.045.858-1.04 1.527.006 1.005.09 2.157.286 3.392l-1.79-.01A24.216 24.216 0 0 1 7 13.59c-.005-1.449.901-2.649 2.117-3.163l9.769-4.145Zm2.266 25.694c8.47-4.174 10.587-13.24 10.615-18.397.005-.67-.416-1.261-1.04-1.527L21.152 7.99v23.986Z"
            />
        </svg>
    );
};
